module.exports = __webpack_public_path__ + "img/enter.4e088de7.png";